import ProfileSettings from "../presentation/views/ProfileSettings.vue";
import Notifications from "../presentation/components/Notifications.vue";
import SecuritySettings from "../presentation/components/SecuritySettings.vue";
import ProfileManagement from "../presentation/components/ProfileManagement.vue";
import PermissionsSettings from "../presentation/components/PermissionsSettings.vue";
/**
 * Settings Module Routes and Navigation
 *
 * This file contains all route definitions and navigation items for the Settings Module.
 * Both routes and navigation items are exported and used by the SettingsModule class.
 */
export const settingsRoutes = [
    {
        path: "/profile",
        name: "ProfileSettings",
        component: ProfileSettings,
        redirect: { name: "ProfileManagement" },
        meta: { requiresAuth: true, titleKey: "profile.title" },
        children: [
            {
                path: "",
                name: "ProfileManagement",
                component: ProfileManagement,
                meta: { requiresAuth: true },
            },
            {
                path: "security",
                name: "SecuritySettings",
                component: SecuritySettings,
                meta: { requiresAuth: true, titleKey: "profile.security" },
            },
            {
                path: "permissions",
                name: "PermissionsSettings",
                component: PermissionsSettings,
                meta: { requiresAuth: true, titleKey: "profile.permissions" },
            },
            {
                path: "notifications",
                name: "Notifications",
                component: Notifications,
                meta: { requiresAuth: true, titleKey: "profile.notifications" },
            },
        ],
    },
];
export const settingsNavigationItems = [
    {
        labelKey: "profile.title",
        children: [
            {
                labelKey: "profile.title",
                path: "/profile",
                meta: { requiresAuth: true },
            },
            {
                labelKey: "profile.security",
                path: "/profile/security",
                meta: { requiresAuth: true },
            },
            {
                labelKey: "profile.permissions",
                path: "/profile/permissions",
                meta: { requiresAuth: true },
            },
            {
                labelKey: "profile.notifications",
                path: "/profile/notifications",
                meta: { requiresAuth: true },
            },
        ],
    },
];
